import React from 'react';
import styled, { css } from 'styled-components';

const stateStyles = {
  idle: css`
    background: #FFF8E7;
    border: 1px solid rgba(218,165,32,0.3);
  `,
  tapped: css`
    background: linear-gradient(135deg, #FFE5B4, #FFD700);
    border: 2px solid #DAA520;
    box-shadow: 0 0 12px rgba(255,215,0,0.6);
    transform: scale(1.05);
  `,
  path: css`
    background: linear-gradient(135deg, #FFF3C4, #FFE28A);
    border: 2px solid #DAA520;
    box-shadow: 0 0 6px rgba(255,215,0,0.4);
    transform: scale(1.02);
  `,
  dimmed: css`
    background: #FFF8E7;
    border: 1px solid rgba(218,165,32,0.15);
    opacity: 0.4;
  `,
};

const Cell = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  padding: 0;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
  border-radius: 6px;
  transition: all 0.25s ease;
  font-family: 'Noto Sans Devanagari', serif;
  min-height: 40px;

  ${p => stateStyles[p.state] || stateStyles.idle}

  &:hover:not(:disabled) {
    border-color: #DAA520;
    transform: scale(1.03);
    box-shadow: 0 2px 6px rgba(218,165,32,0.2);
  }

  &:focus-visible {
    outline: 2px solid #DAA520;
    outline-offset: 2px;
  }
`;

const DevChar = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #5D3A1A;
  line-height: 1;

  @media (max-width: ${p => p.theme.breakpoints.mobile}px) {
    font-size: 16px;
  }
`;

const TamilChar = styled.span`
  font-size: 10px;
  color: #9B8B7A;
  font-family: 'Noto Sans Tamil', sans-serif;
  margin-top: 2px;
  line-height: 1;
`;

const ShalakaCell = ({ devanagari, tamil, state, cellIndex, onTap, disabled }) => {
  const label = `letter ${devanagari}, cell ${cellIndex + 1} of 81`;
  const nonInteractive = state === 'dimmed' || state === 'path' || state === 'tapped';

  return (
    <Cell
      role="gridcell"
      aria-label={label}
      state={state}
      onClick={onTap}
      disabled={disabled || nonInteractive}
      tabIndex={state === 'idle' && !disabled ? 0 : -1}
    >
      <DevChar>{devanagari}</DevChar>
      {tamil && <TamilChar>{tamil}</TamilChar>}
    </Cell>
  );
};

export default ShalakaCell;
